(() => {
  if (window.ppContentInitialized) return;
  window.ppContentInitialized = true;
  function init(root = document) {
    root.querySelectorAll('[data-pp-content]').forEach(section => {
      if (section.dataset.ppReady) return;
      section.dataset.ppReady = 'true';
      const prose = section.querySelector('[data-pp-prose]');
      if (!prose) return;
      prose.querySelectorAll('table').forEach(table => {
        if (table.closest('.ppc-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'ppc-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        const parentHeading = table.closest('section')?.querySelector('h2');
        if (parentHeading) wrapper.setAttribute('aria-label', parentHeading.textContent.trim());
        table.before(wrapper);
        wrapper.append(table);
      });
      const toc = section.querySelector('[data-pp-toc]');
      if (!toc) return;
      const headings = [...prose.querySelectorAll('h2,h3')].filter(h => h.textContent.trim() && !h.closest('[hidden], [style*="display: none"], [style*="display:none"]'));
      if (headings.length < 2) return;
      const nav = toc.querySelector('nav');
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = 'pp-content-' + section.closest('[id]').id + '-' + i;
        const a = document.createElement('a');
        a.href = '#' + encodeURIComponent(heading.id);
        a.textContent = heading.textContent.trim();
        nav.append(a);
      });
      toc.hidden = false;
    });
    root.querySelector('[data-pp-feedback]')?.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
